import { Element, useEditor } from '@craftjs/core';
import Tooltip from '@mui/material/Tooltip';
import {
  AlignVerticalSpaceAround,
  Box,
  Image,
  Type,
  Utensils,
  Flag,
  MousePointerClick,
  Share2,
  MapPinned,
  FileQuestion,
  Menu,
  ShoppingBag,
  Square,
} from 'lucide-react';
import SectionBlock from '@/components/editor/blocks/section-block/SectionBlock';
import ContainerBlock from '@/components/editor/blocks/ContainerBlock';
import TextBlock from '@/components/editor/blocks/TextBlock';
import ImageBlock from '@/components/editor/blocks/ImageBlock';
import DishBlock from '@/components/editor/blocks/DishBlock';
import VerticalSpacerBlock from '@/components/editor/blocks/VerticalSpacerBlock';
import SocialMediaBlock from '@/components/editor/blocks/SocialMediaBlock';
import ButtonBlock from '@/components/editor/blocks/ButtonBlock';
import MapBlock from '@/components/editor/blocks/MapBlock';
import FaqsBlock from '@/components/editor/blocks/FaqsBlock';
import MenuBlock from '@/components/editor/blocks/MenuBlock';
import CartBlock from '../../blocks/CartBlock';
import RegionBlock from '../../blocks/RegionBlock';
import './styles.scss';

const Toolbox = () => {
  const {
    connectors: { create },
  } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  return (
    <div className="editor__toolbox">
      <div
        className="tool"
        ref={(ref: any) => create(ref, <Element canvas is={SectionBlock} />)}
      >
        <Tooltip title="Sección" placement="left" arrow>
          <Flag className="tool__icon" />
        </Tooltip>
      </div>
      <div
        className="tool"
        ref={(ref: any) => create(ref, <Element canvas is={ContainerBlock} />)}
      >
        <Tooltip title="Contenedor" placement="left" arrow>
          <Box className="tool__icon" />
        </Tooltip>
      </div>
      <div
        className="tool"
        ref={(ref: any) => create(ref, <VerticalSpacerBlock />)}
      >
        <Tooltip title="Espaciado Vertical" placement="left">
          <AlignVerticalSpaceAround />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <ImageBlock />)}>
        <Tooltip title="Imagen" placement="left">
          <Image />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <TextBlock />)}>
        <Tooltip title="Texto" placement="left">
          <Type />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <ButtonBlock />)}>
        <Tooltip title="Botón" placement="left">
          <MousePointerClick />
        </Tooltip>
      </div>
      <div
        className="tool"
        ref={(ref: any) => create(ref, <SocialMediaBlock />)}
      >
        <Tooltip title="Redes Sociales" placement="left">
          <Share2 />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <DishBlock />)}>
        <Tooltip title="Plato" placement="left">
          <Utensils />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <MapBlock />)}>
        <Tooltip title="Mapa" placement="left">
          <MapPinned />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <FaqsBlock />)}>
        <Tooltip title="FAQs" placement="left">
          <FileQuestion />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <MenuBlock />)}>
        <Tooltip title="Menu" placement="left">
          <Menu />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <CartBlock />)}>
        <Tooltip title="Cart" placement="left">
          <ShoppingBag />
        </Tooltip>
      </div>
      <div className="tool" ref={(ref: any) => create(ref, <RegionBlock />)}>
        <Tooltip title="Region" placement="left">
          <Square />
        </Tooltip>
      </div>
    </div>
  );
};

export default Toolbox;
